<div class="kt-modal" data-kt-modal="true" [id]="modalId">
  <div class="kt-modal-content max-w-[420px] top-[20%]">
    <div class="kt-modal-header">
      <h3 class="kt-modal-title">{{ title }}</h3>
      <button
        type="button"
        class="kt-modal-close"
        aria-label="Close modal"
        [attr.data-kt-modal-dismiss]="'#' + modalId"
        (click)="cancel.emit()"
      >
        <i class="ki-filled ki-cross" aria-hidden="true"></i>
      </button>
    </div>

    <div class="kt-modal-body">
      <div class="flex items-start gap-3">
        <div class="kt-avatar kt-avatar-outline size-10 border-destructive/30 text-destructive">
          <i class="ki-filled ki-information-1 text-2xl" aria-hidden="true"></i>
        </div>
        <div class="grid gap-1">
          <p class="font-medium">{{ message }}</p>
          <p class="text-sm text-secondary-foreground">
            This action cannot be undone.
          </p>
        </div>
      </div>
    </div>

    <div class="kt-modal-footer flex justify-end gap-2">
      <button
        type="button"
        class="kt-btn kt-btn-light"
        [attr.data-kt-modal-dismiss]="'#' + modalId"
        [disabled]="confirming"
        (click)="cancel.emit()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="kt-btn kt-btn-destructive"
        (click)="confirm.emit()"
        [disabled]="confirming"
      >
        <span class="inline-flex items-center gap-2">
          @if (confirming) {
            <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true"></span>
          }
          <span>{{ confirmLabel }}</span>
        </span>
      </button>
    </div>
  </div>
</div>
